export default class AppHelper {
}
AppHelper.namedPropsToArray = function (obj, baseName) {
    var result = [];
    for (var key in obj) {
        if (key.indexOf(baseName) === 0) {
            result.push(obj[key]);
        }
    }
    return result;
};
AppHelper.arrayToNamedProps = function (arr, baseName, obj = undefined) {
    if (obj) {
        for (var key in obj) {
            if (key.indexOf(baseName) === 0) {
                delete obj[key];
            }
        }
    }
    var result = obj || {};
    var idx = 0;
    arr.forEach(function (elem) {
        result[baseName + (idx++)] = elem;
    });
    return result;
};
